import { render, staticRenderFns } from "./PageNotAllowed.vue?vue&type=template&id=37f0d01d&scoped=true&"
var script = {}
import style0 from "./PageNotAllowed.vue?vue&type=style&index=0&id=37f0d01d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f0d01d",
  null
  
)

export default component.exports